import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.createAccount(result => {
      commit('setAccountInfo', result.data.data)
      resolve(result.data.data)
    }, param)
  })
}
